export const queryPage = '/analysis/system/analysis/source/source_page'
export const batchUpdateOrDelete = '/analysis/system/analysis/source/batch_update_or_delete'
export const saveOrUpdate = '/analysis/system/analysis/source/save_or_update'
import request from "@/utils/request";
/**执行SQL*/
export function executor_sql(data) {
  return request({
    url: '/analysis/system/analysis/source/executor_sql',
    method: "post",
    data,
  });
}
/**获取数据源详情*/
export function get_detail(params) {
  return request({
    url: '/analysis/system/analysis/source/get_detail',
    method: "get",
    params,
  });
}
